// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fgYw","footer":"styles_footer__1LlcU"};